module.exports = __webpack_public_path__ + "static/img/PORSCHE.4270529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/PORSCHE.png
// module id = CFzX
// module chunks = 1